import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit
} from '@angular/core';
import { VexPopoverRef } from '@vex/components/vex-popover/vex-popover-ref';
import { MatRippleModule } from '@angular/material/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { AuthService } from '../../../../../core/auth/auth.service';
import { ChangePasswordDialogComponent } from '../../../../../core/auth/change-password-dialog/change-password-dialog.component';

@Component({
  selector: 'vex-toolbar-user-dropdown',
  templateUrl: './toolbar-user-dropdown.component.html',
  styleUrls: ['./toolbar-user-dropdown.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    MatIconModule,
    MatButtonModule,
    MatRippleModule,
    MatDialogModule
  ]
})
export class ToolbarUserDropdownComponent implements OnInit {
  userName: string = '';

  constructor(
    private cd: ChangeDetectorRef,
    private popoverRef: VexPopoverRef<ToolbarUserDropdownComponent>,
    private authService: AuthService,
    private dialog: MatDialog
  ) {}

  ngOnInit() {
    this.authService.currentUser$.subscribe(user => {
      this.userName = user?.full_name || user?.usuario || '';
      this.cd.markForCheck();
    });
  }

  close() {
    this.popoverRef.close();
  }

  openChangePassword() {
    this.popoverRef.close();
    this.dialog.open(ChangePasswordDialogComponent, {
      width: '420px',
      disableClose: false,
    });
  }

  logout() {
    this.popoverRef.close();
    this.authService.logout().subscribe({
      next: () => { /* session cleared, navigation handled by service */ },
      error: (err) => console.error('[Logout] error (session cleared anyway):', err)
    });
  }
}
